module.exports = __webpack_public_path__ + "static/photo-header-ff5222384435f2f2e86d936654463e1c.jpg";